"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCheckOffertaEvent = exports.setSelectSupplierIdEvent = exports.setFetchSuppliersEvent = void 0;
var databus_1 = require("@portals/databus");
var constants_1 = require("./constants");
var setFetchSuppliersEvent = function (params) {
    new databus_1.Databus({ name: constants_1.FETCH_SUPPLIERS }).addEvent({
        detail: params,
    });
    databus_1.Databus.dispatchEvent({ eventName: constants_1.FETCH_SUPPLIERS });
};
exports.setFetchSuppliersEvent = setFetchSuppliersEvent;
var setSelectSupplierIdEvent = function (supplierId) {
    new databus_1.Databus({ name: constants_1.SELECTED_SUPPLIER_ID }).addEvent({
        detail: { supplierId: supplierId },
    });
    databus_1.Databus.dispatchEvent({ eventName: constants_1.SELECTED_SUPPLIER_ID });
};
exports.setSelectSupplierIdEvent = setSelectSupplierIdEvent;
var setCheckOffertaEvent = function (params) {
    new databus_1.Databus({ name: constants_1.CHECK_OFFERTA }).addEvent({
        detail: params,
    });
    databus_1.Databus.dispatchEvent({ eventName: constants_1.CHECK_OFFERTA });
};
exports.setCheckOffertaEvent = setCheckOffertaEvent;
